module.exports = __webpack_public_path__ + "img/asset.3bf6f472.svg";